import axiosInstance from "../../../utils/axios";

const path = "common/cms";

export const FAQ = async () => {
    return await axiosInstance().get(`${path}/faq`);
};
